import type { Description } from '../../schemas'

interface ParagraphProcessingOptions {
  showCounters: boolean
  counter?: number
  keyPrefix?: string
}

interface ProcessedParagraph {
  key: string
  text: string
  counter: number
  shouldShowCounter: boolean
  isEmpty: boolean
}

export function processDescriptionParagraphs(
  descriptions: Description[],
  options: ParagraphProcessingOptions
): ProcessedParagraph[] {
  const {
    showCounters,
    counter: initialCounter = 1,
    keyPrefix = 'description',
  } = options

  let counter = initialCounter
  const results: ProcessedParagraph[] = []

  for (const description of descriptions) {
    const isEmpty = description.plainText.trim() === ''
    const shouldShowCounter =
      showCounters && !isEmpty && description.category === null
    const currentCounter = shouldShowCounter ? counter++ : 0

    const key = `${keyPrefix}-${description.descriptionId}-${description.lang}-${description.loadSource}`

    results.push({
      key,
      text: description.plainText,
      counter: currentCounter,
      shouldShowCounter,
      isEmpty,
    })
  }

  return results
}
